import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SectionMasterService {

  AppUrl: string = "";
  constructor(private readonly _httpClient: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.AppUrl = sessionStorage.getItem("BaseURL") || '';
    }
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  i360GetProductsForSections(TokenKey: string): Observable<any> {
    this.setAPIUrl();
    let data = 'api/SectionMaster/i360GetProductsForSections';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._httpClient.get<any>(this.AppUrl + data, httpOptions).pipe(catchError(this.handleError));
  }

  i360SectionsAddUpdate(TokenKey: string, trainingModel: any): Observable<any> {
    this.setAPIUrl();
    let data = 'api/SectionMaster/AddUpdateSections';
    const httpOptions = { headers: new HttpHeaders({ 'Accept': 'application/json', 'Token': TokenKey }) };
    return this._httpClient.post<any>(this.AppUrl + data, trainingModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  i360SectionGet(TokenKey: string, filterModel: any): Observable<any> {
    this.setAPIUrl();
    let data = 'api/SectionMaster/i360SectionGet';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._httpClient.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  i360SectionFindbySectionId(TokenKey: string, sectionId: number): Observable<any> {
    this.setAPIUrl();
    let data = 'api/SectionMaster/i360SectionFindbySectionId/' + sectionId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._httpClient.get<any>(this.AppUrl + data, httpOptions).pipe(catchError(this.handleError));
  }

  i360SectionDelete(TokenKey: string, sectionId: any): Observable<any> {
    this.setAPIUrl();
    let data = 'api/SectionMaster/i360SectionDelete';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._httpClient.post<any>(this.AppUrl + data, sectionId, httpOptions)
      .pipe(catchError(this.handleError));
  }
}